import { baseUrl, facebook_id } from "./config";

const defaultTitle = "KonfHub is Best AI Powered Event Management Platform for Seamless Event Planning and Ticketing";
const defaultDescription =
	"Streamline event planning with KonfHub. Top Event Management Platform for conferences, marathons & meetups. Manage registrations, ticketing & attendee tracking effortlessly.";

export const defaultSeo = {
	title: defaultTitle,
	titleTemplate: "%s",
	description: defaultDescription,
	canonical: `${baseUrl}/`,
	openGraph: {
		url: `${baseUrl}/`,
		title: defaultTitle,
		description: defaultDescription,
		site_name: "KonfHub",
		type: "website", // Adding og:type
		images: [
			{
				url: "https://d2nnrpx7gk2my2.cloudfront.net/files/67304149449e490008b907f6/image(9).png",
				width: 800,
				height: 600,
				alt: "KonfHub",
				type: "image/png"
			}
		],
		fb_app_id: `${facebook_id}`
	},
	twitter: {
		handle: "@KonfHub",
		site: "@KonfHub",
		cardType: "summary_large_image"
	}
};

export const seoFunct = pageSeo => {
	const seoItems = {
		homeSeo: {
			title: defaultTitle,
			description: defaultDescription,
			canonicalRoute: ""
		},
		eventsSeo: {
			title: "Upcoming Events on KonfHub - Join Events Near You",
			description: "Find upcoming events on KonfHub: tech conferences, sports events, marathons, concerts & more. Discover events matching your interests on our platform.",
			canonicalRoute: "/events"
		}
	};
	return {
		title: seoItems[pageSeo].title,
		titleTemplate: "%s",
		description: seoItems[pageSeo].description,
		canonical: `${baseUrl}/${seoItems[pageSeo].canonicalRoute}`,
		openGraph: {
			url: `${baseUrl}/${seoItems[pageSeo].canonicalRoute}`,
			title: seoItems[pageSeo].title,
			description: seoItems[pageSeo].description,
			site_name: "KonfHub",
			images: [
				{
					url: "https://d2nnrpx7gk2my2.cloudfront.net/files/67304149449e490008b907f6/image(9).png",
					width: 800,
					height: 600,
					alt: "KonfHub",
					type: "image/jpeg"
				}
			]
		},
		twitter: {
			handle: "@KonfHub",
			site: "@KonfHub",
			cardType: "summary_large_image"
		}
	};
};